import * as React from "react"
import {Grid} from "@mui/material";

import UserActivityCards from "./Card";
import UserActivitiesEvolution from "./Evolution";
import UserActivityTops from "./Tops"
import UserActivityTable from "./Table"


export default function UserActivityContent() {
    return <Grid container spacing={2}>
        <Grid container spacing={3} sx={{marginTop:1, marginLeft:-0.7}}>
            <Grid item xs={6}>
                <UserActivityCards
                    title="Total Active users VS Previous Period"
                    api="users"
                />
            </Grid>

            <Grid item xs={6}>
                <UserActivityCards
                    title="Total Submits VS Previous Period"
                    api="submits"
                />
            </Grid>
        </Grid>

        <Grid item xs={12}>
            <UserActivityTops />
        </Grid>

         <Grid item xs={12}>
             <UserActivitiesEvolution />
         </Grid>

         <Grid item xs={12}>
             <UserActivityTable/>
         </Grid>
    </Grid>
}